import * as S from './DateSelector.style';
import { useEffect, useState } from 'react';
import moment from 'moment/moment';
import { TextInputNoLine } from '../../../design_system/components/input/Inputs';

const DateSelector = ({ onDateChange }) => {
    const [dateType, setDateType] = useState('daily'); // 'daily'|'weekly'|'monthly'|'custom'
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const onStartDateChange = (e) => {
        const value = moment(e.target.value);
        const end = moment(endDate);
        if (value.isAfter(end)) {
            alert('올바른 날짜를 선택해 주세요');
        } else {
            setDateType('custom');
            setStartDate(e.target.value);
        }
    };
    const onEndDateChange = (e) => {
        const value = moment(e.target.value);
        const start = moment(startDate);
        if (value.isBefore(start)) {
            alert('올바른 날짜를 선택해 주세요');
        } else {
            setDateType('custom');
            setEndDate(e.target.value);
        }
    };

    const handleChangeDateType = (type) => {
        if (type !== 'custom') {
            setStartDate('');
            setEndDate('');
        }
        setDateType(type);
    };

    useEffect(() => {
        onDateChange({ dateType, startDate, endDate });
    }, [dateType, startDate, endDate]);

    return (
        <S.ButtonWrapper>
            <S.TypeInputContainer>
                <S.DateTypeButton type={'button'} value={'오늘'} $isSelected={dateType === 'daily'} onClick={() => handleChangeDateType('daily')} />
                <S.DateTypeButton type={'button'} value={'이번 주'} $isSelected={dateType === 'weekly'} onClick={() => handleChangeDateType('weekly')} />
                <S.DateTypeButton type={'button'} value={'이번 달'} $isSelected={dateType === 'monthly'} onClick={() => handleChangeDateType('monthly')} />
                <S.DateTypeButton type={'button'} value={'직접입력'} $isSelected={dateType === 'custom'} />
            </S.TypeInputContainer>
            <S.TextInputNoLineWrapper id="date-format">
                <TextInputNoLine style={{ borderBottom: `1px solid rgb(171 171 171)` }} type={'date'} value={startDate} onChange={onStartDateChange} />
                <span>~</span>
                <TextInputNoLine style={{ borderBottom: `1px solid rgb(171 171 171)` }} type={'date'} value={endDate} onChange={onEndDateChange} />
            </S.TextInputNoLineWrapper>
        </S.ButtonWrapper>
    );
};

export default DateSelector;
